var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGermanyFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xEB\\xCE\\xD3\\xC8_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 1339.585",
    style: {
      enableBackground: "new 0 0 2000 1339.585"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 331.153,
    y: -329.861,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1670.2159 -331.3606)",
    style: {
      fill: "#DD0000"
    },
    width: 1339.271,
    height: 1998.577
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 775.387,
    y: -773.749,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 1226.3275 -775.5943)",
    width: 451.148,
    height: 1998.231
  })), /*#__PURE__*/React.createElement("rect", {
    x: 777.211,
    y: 116.198,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 2116.2744 114.3525)",
    style: {
      fill: "#FFCE00"
    },
    width: 447.499,
    height: 1998.231
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermanyFlag);
export default __webpack_public_path__ + "static/media/germany_flag.e6ba706d4cba30f6362e49f1bc77a424.svg";
export { ForwardRef as ReactComponent };